// src/components/common/LegalModal/LegalModal.jsx
import React from 'react';
import { ButtonLarge } from '../buttons/ButtonLarge/ButtonLarge';

import './legal-modal.css';

/**
 * Full-screen Privacy Policy / Terms & Conditions view, opened from the
 * Account screen's "Legal" section — matches Figma node 3349:2316
 * ("Account - Privacy Policy"): a dedicated screen with its own header
 * (title + effective date), a scrollable document body with a bottom
 * gradient fade, and a single full-width "Close" button, not a small
 * floating dialog.
 *
 * Rendered as a sibling of .account-content inside .account-screen
 * (position: absolute, not position: fixed like ConfirmModal) so it
 * scales with ScaleWrapper's canvas zoom exactly like every other
 * screen — see the comment on .legal-screen in legal-modal.css.
 * Account stays mounted underneath, so closing returns to the same
 * scroll position instead of losing it.
 *
 * @param {boolean} isOpen
 * @param {string} title
 * @param {string} [effectiveDate] - e.g. "September 7, 2026"
 * @param {string} bodyHtml - trusted, hardcoded HTML fragment (see
 *   src/content/legalContent.js) — never user-supplied content.
 * @param {function} onClose
 */
export const LegalModal = ({ isOpen, title, effectiveDate, bodyHtml, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="legal-screen">
      <div className="legal-screen-inner">
        <div className="legal-screen-header">
          <h1 className="legal-screen-title">{title}</h1>
          {effectiveDate && (
            <p className="legal-screen-date">Effective Date: {effectiveDate}</p>
          )}
          <div className="legal-screen-header-line" />
        </div>
      </div>

      <div className="legal-screen-body">
        <div
          className="legal-screen-content"
          // bodyHtml is a hardcoded constant from src/content/legalContent.js,
          // never user input — see the component doc comment above.
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
        <div className="legal-screen-bottom-spacer" />
      </div>

      <div className="legal-screen-gradient" aria-hidden="true" />

      <div className="legal-screen-footer">
        <ButtonLarge
          text="Close"
          buttonLargeClassName="button-large legal-screen-close-button"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default LegalModal;
